/**
 * Shared ErrorBanner Component
 *
 * Consistent error banner with optional retry action.
 * Replaces ad-hoc error banners across Dashboard, Invoices, Support.
 */

interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
  return (
    <div className="animate-fade-up rounded-lg border border-brand-error-200 bg-brand-error-50 p-4">
      <p className="text-sm font-medium text-brand-error-800">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 text-sm font-medium text-brand-error-600 underline hover:text-brand-error-700"
        >
          Try again
        </button>
      )}
    </div>
  );
}
